import { useState } from "react";
import { useCultures, normCulture, AUTRE } from "@/lib/cultures";

/**
 * Choix d'une culture : liste du référentiel de la région, ou « Autre » + saisie libre (la culture saisie
 * apparaît ensuite dans l'écran admin « Cultures », section « À rattacher »).
 */
export default function CulturePicker({ value, onChange, region, placeholder = "Culture…", className = "", inputClassName = "", testId }) {
  const list = useCultures(region, { saisie: true });
  const matched = value ? list.find((c) => normCulture(c) === normCulture(value)) : null;
  const [free, setFree] = useState(false);
  // Valeur déjà enregistrée hors liste (ex. « Surface en herbe diverse ») : gardée comme choix possible
  const options = value && !matched && !free ? [value, ...list] : list;
  const selectValue = free ? AUTRE : (matched || value || "");

  return (
    <div className="flex flex-col gap-1.5 min-w-0 flex-1">
      <select
        value={selectValue}
        onChange={(e) => {
          const v = e.target.value;
          if (v === AUTRE) { setFree(true); onChange(""); } else { setFree(false); onChange(v); }
        }}
        className={`h-9 w-full min-w-0 rounded-md border border-black/10 bg-white px-2 text-sm ${className}`}
        data-testid={testId}
        aria-label="Culture"
      >
        <option value="">{placeholder}</option>
        {options.map((c) => <option key={c} value={c}>{c}</option>)}
        <option value={AUTRE}>Autre (saisie libre)…</option>
      </select>
      {free && (
        <input
          autoFocus
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Nom de votre culture"
          className={`h-9 w-full rounded-md border border-black/10 bg-white px-2 text-sm ${inputClassName}`}
          data-testid={testId ? `${testId}-free` : undefined}
        />
      )}
    </div>
  );
}
